import { clsx } from "clsx";

import styles from "./Kbd.module.css";

/** A keyboard shortcut hint. Each key is passed separately: <Kbd keys={["Ctrl", "K"]} />. */
export function Kbd({ keys, className }: { keys: readonly string[]; className?: string }) {
  return (
    <span className={clsx(styles.group, className)}>
      {keys.map((key) => (
        <kbd key={key} className={styles.key}>
          {key}
        </kbd>
      ))}
    </span>
  );
}
